






































import { Component, Mixins, Prop } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";

import { UsersManagementService } from "@/services/api/users-management.service";

@Component({
  components: {},
  watch: {
    value: "init",
  },
})
export default class UserEmailConfirmationDialog extends Mixins(FormValidator) {
  loading = false;
  isResent: boolean = false;

  @Prop()
  value: boolean;
  @Prop()
  readonly email: string;
  @Prop()
  readonly user_rid: string;

  init() {
    this.isResent = false;
  }

  async close() {
    this.$emit("input", false);
  }

  async resendEmail() {
    this.loading = true;
    const response = await UsersManagementService.resendUserEmaiVerification(
      this.user_rid,
    );

    if (response.status === 200) {
      this.isResent = true;
    }

    this.loading = false;
  }
}
